export const AVAILABILITY_STATUS = {
    AVAILABLE: 'available',
    RESERVED: 'reserved',
    SOLD: 'sold', //TODO: refactor bim-weblo-panel to use 'sold' instead of 'sell'
    UNKNOWN: 'unknown',
};